import { Component, OnDestroy } from '@angular/core';
import { AuthenticationService } from '@app/core/services/auth.service';
import { License } from '@app/models/license/license.model';
import { LicenseService } from '@app/services/license/license.service';
import { onErrorAlert } from 'common/helper';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { DEFAULT_URL } from '../../app.constant';

@Component({
    selector: 'app-menu-license-list',
    templateUrl: './menu-license-list.component.html',
    standalone: false
})
export class MenuLicenseListComponent implements OnDestroy {

  private subs = new Subscription();

  public licenseList: License[] = [];
  public selectedLicense: License;

  constructor(
    public licenseService: LicenseService,
    private alert: ToastrService,
    private authService: AuthenticationService
  ) {
    const sub = this.licenseService.getAllLicenses().subscribe({
      next: (licenses) => {
        // Alphabetise by the displayed organisation/company name (case-insensitive).
        this.licenseList = [...licenses].sort((a, b) =>
          (a.organisationName ?? '').localeCompare(
            b.organisationName ?? '', undefined, { sensitivity: 'base' }));
        const selectedId = this.authService.currentUser?.licenseId;
        if (selectedId) {
          this.selectedLicense = this.licenseList.find(item => item.id === selectedId);
        }
        if (!this.selectedLicense) {
          this.selectedLicense = this.licenseList[0];
        }
      },
      error: (e) => {
        onErrorAlert(this.alert, e);
      },
    });

    this.subs.add(sub);
  }


  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  selectionChanged = (id: number) => {
    if (id) {
      const sub = this.authService
        .changeLicense(id)
        .subscribe({
          next: () => {
            // A full page load is required, not just a route change: the licence lives in
            // server-side session state, while permissions, menus, terminology and the current
            // user are all cached in memory here. Only a reload rebuilds every one of them
            // against the new licence.
            //
            // Setting href does that in ONE load. The previous router.navigate + reload pair
            // rendered the dashboard first, firing a complete set of API calls that the reload
            // then destroyed mid-flight — wasted work, and the aborted requests surfaced on the
            // server as Kestrel "Unexpected end of request content" every single time.
            // Navigating to DEFAULT_URL still matters: it avoids reloading a deep link that
            // belongs to the licence we just left.
            window.location.href = `/${DEFAULT_URL}`;
          },
          error: (e) => onErrorAlert(this.alert, e),
        });
      this.subs.add(sub);
    }
  }
}
